import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import context from "../GlobalData/dataProvider";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import "./starterFormStyle.css";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
export default function StartForm() {
  let navigate = useNavigate();
  let dataContext = useContext(context);
  const classes = useStyles();
  const [district, setDistrict] = React.useState("");
  const [Gender, setGender] = React.useState("");
  const [age, setAge] = React.useState("");
  console.log("Age first :", district);
  const handleChange = (event) => {
    setDistrict(event.target.value);
    console.log("Age After :", district);
  };
  const SubmitForm = () => {
    console.log("Helo");
    dataContext = Number(district) + Number(Gender) + Number(age);
    console.log("Helo final is : ", dataContext);

    navigate("/survey");
  };

  return (
    <>
      <div className="introInfoConatainer">
        <div className="innerIntroInfoConatainer">
          <form onSubmit={SubmitForm}>
            <div style={{ paddingBottom: "20px" }}>
              <FormControl variant="filled" className={classes.formControl}>
                <InputLabel id="demo-simple-select-filled-label">
                  Gender
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={Gender}
                  onChange={(event) => {
                    setGender(event.target.value);
                    console.log("Gender: ", Gender);
                  }}
                  required
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>

                  <MenuItem value={5}>Male</MenuItem>
                  <MenuItem value={10}>Female</MenuItem>
                  <MenuItem value={15}>Trans/Gay</MenuItem>
                  <MenuItem value={0}>Other</MenuItem>
                  <MenuItem value={0}>Decline to Answer</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={{ paddingBottom: "20px" }}>
              <FormControl variant="filled" className={classes.formControl}>
                <InputLabel id="demo-simple-select-filled-label">
                  Age
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={age}
                  onChange={(event) => {
                    setAge(event.target.value);
                    console.log("Age final Group: ", age);
                  }}
                  required
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={10}>15-20</MenuItem>
                  <MenuItem value={9}>21-26</MenuItem>
                  <MenuItem value={6}>27-30</MenuItem>
                  <MenuItem value={5}>31-35</MenuItem>
                  <MenuItem value={4}>Above 35</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div style={{ paddingBottom: "20px" }}>
              <FormControl variant="filled" className={classes.formControl}>
                <InputLabel id="demo-simple-select-filled-label">
                  District
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={district}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>Larkana</MenuItem>
                  <MenuItem value={0}>Nawab shah</MenuItem>
                  <MenuItem value={5}>Karachi</MenuItem>
                  <MenuItem value={0}>Sheikhupura</MenuItem>
                  <MenuItem value={0}>D.G. khan</MenuItem>
                  <MenuItem value={0}>Gujrat</MenuItem>
                  <MenuItem value={0}>Sialkot</MenuItem>
                  <MenuItem value={0}>Kasur</MenuItem>
                  <MenuItem value={0}>Turbat</MenuItem>
                  <MenuItem value={0}>Mirpur</MenuItem>
                  <MenuItem value={0}>Quetta</MenuItem>
                  <MenuItem value={0}>Multan</MenuItem>
                  <MenuItem value={5}>Peshawar</MenuItem>
                  <MenuItem value={0}>Sargodha</MenuItem>
                  <MenuItem value={5}>Bannu</MenuItem>
                  <MenuItem value={5}>Nawab shah</MenuItem>
                  <MenuItem value={5}>Hyderabad</MenuItem>
                  <MenuItem value={5}>Sukkur</MenuItem>
                  <MenuItem value={5}>Rawalpindi</MenuItem>
                  <MenuItem value={5}>Lahore</MenuItem>
                  <MenuItem value={5}>Jehlum</MenuItem>
                  <MenuItem value={5}>Mirpurkhas</MenuItem>
                  <MenuItem value={5}>Kasur</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <Button type="submit" variant="contained" color="primary">
                Done
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
